
import React from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { History, SquareLibrary, House } from "lucide-react";

interface SidebarNavigationProps {
  isActivePath: (path: string) => boolean;
  onLinkClick?: () => void;
  isCollapsed?: boolean;
  user: any;
}

const SidebarNavigation: React.FC<SidebarNavigationProps> = ({ 
  isActivePath, 
  onLinkClick, 
  isCollapsed = false,
  user 
}) => {
  const [searchParams] = useSearchParams();
  const isViewingHistoricTarget = searchParams.has('target');
  
  // Home is active only when on "/" without viewing a historic target
  const isHomeActive = isActivePath('/') && !isViewingHistoricTarget;
  // History is active on /history OR when viewing a historic target from home
  const isHistoryActive = isActivePath('/history') || (isActivePath('/') && isViewingHistoricTarget);
  
  return (
    <div className={`flex flex-col ${isCollapsed ? "space-y-2" : "space-y-2"}`}>
      <Link 
        to="/" 
        onClick={onLinkClick}
        className={`flex items-center ${isCollapsed ? "justify-center" : ""} py-3 px-4 rounded-md transition-colors ${isHomeActive ? 'bg-secondary text-secondary-foreground' : 'text-sidebar-foreground hover:bg-secondary/80 hover:text-secondary-foreground active:bg-secondary/60 active:scale-95'}`}
      >
        <House className={`min-w-[24px] w-6 h-6 ${isHomeActive ? 'text-secondary-foreground' : 'text-sidebar-foreground'}`} />
        {!isCollapsed && (
          <span className={`ml-3 ${isHomeActive ? 'text-secondary-foreground font-medium' : 'text-sidebar-foreground'}`}>Home</span>
        )}
      </Link>

      {user && (
        <Link 
          to="/history"
          onClick={onLinkClick}
          className={`flex items-center ${isCollapsed ? "justify-center" : ""} py-3 px-4 rounded-md transition-colors ${isHistoryActive ? 'bg-secondary text-secondary-foreground' : 'text-sidebar-foreground hover:bg-secondary/80 hover:text-secondary-foreground active:bg-secondary/60 active:scale-95'}`}
        >
          <History className={`min-w-[24px] w-6 h-6 ${isHistoryActive ? 'text-secondary-foreground' : 'text-sidebar-foreground'}`} />
          {!isCollapsed && (
            <span className={`ml-3 ${isHistoryActive ? 'text-secondary-foreground font-medium' : 'text-sidebar-foreground'}`}>History</span>
          )}
        </Link>
      )}

      <Link 
        to="/about"
        onClick={onLinkClick}
        className={`flex items-center ${isCollapsed ? "justify-center" : ""} py-3 px-4 rounded-md transition-colors ${isActivePath('/about') ? 'bg-secondary text-secondary-foreground' : 'text-sidebar-foreground hover:bg-secondary/80 hover:text-secondary-foreground active:bg-secondary/60 active:scale-95'}`}
      >
        <SquareLibrary className={`min-w-[24px] w-6 h-6 ${isActivePath('/about') ? 'text-secondary-foreground' : 'text-sidebar-foreground'}`} />
        {!isCollapsed && (
          <span className={`ml-3 ${isActivePath('/about') ? 'text-secondary-foreground font-medium' : 'text-sidebar-foreground'}`}>About RV</span>
        )}
      </Link>
    </div>
  );
};

export default SidebarNavigation;
